import { StorageProvider } from "@dashboard-v3/api";
import { useTranslation } from "react-i18next";

export default function StorageProviderLabel(props: {
  value: StorageProvider;
}) {
  const { t } = useTranslation("rules");
  return <>{t(translationKey(props.value))}</>;
}

export const translationKey = (storageProvider: StorageProvider) =>
  `rules:cloudStorage.header.subtitle.${storageProvider}`;

export const selectProvider = `rules:cloudStorage.header.subtitle.default`;
